import { motion } from 'framer-motion';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
      <Navbar />
      <main className="pt-24 pb-20">
        <div className="section-container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="label-text text-[#6B7280] block mb-4">Legal</span>
            <h1 className="heading-lg text-3xl md:text-4xl lg:text-5xl text-[#1E3A5F] mb-8">
              Privacy Policy
            </h1>
            <p className="text-[#6B7280] mb-8">Last updated: January 2026</p>
            
            <div className="prose prose-lg max-w-4xl text-[#4B5563]">
              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">1. Introduction</h2>
                <p className="mb-4">
                  Easysend ("we", "us", or "our") is committed to protecting your privacy. This Privacy Policy 
                  explains how we collect, use, disclose, and safeguard your information when you use our payment 
                  infrastructure services.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">2. Information We Collect</h2>
                <p className="mb-4">We may collect the following types of information:</p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li><strong>Identity Information:</strong> Name, date of birth, nationality, government-issued identification</li>
                  <li><strong>Contact Information:</strong> Email address, phone number, postal address</li>
                  <li><strong>Financial Information:</strong> Bank account details, transaction history, payment information</li>
                  <li><strong>Business Information:</strong> Company name, registration details, beneficial ownership</li>
                  <li><strong>Technical Information:</strong> IP address, device information, browser type</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">3. How We Use Your Information</h2>
                <p className="mb-4">We use your information to:</p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>Provide and maintain our payment services</li>
                  <li>Process transactions and send related information</li>
                  <li>Comply with legal and regulatory requirements</li>
                  <li>Prevent fraud and enhance security</li>
                  <li>Communicate with you about our services</li>
                  <li>Improve our products and services</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">4. Legal Basis for Processing</h2>
                <p className="mb-4">We process your personal data based on:</p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>Performance of a contract with you</li>
                  <li>Compliance with legal obligations</li>
                  <li>Our legitimate business interests</li>
                  <li>Your consent, where applicable</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">5. Data Sharing</h2>
                <p className="mb-4">
                  We may share your information with banking partners, payment networks, regulatory authorities, 
                  and service providers who assist us in operating our business. We ensure appropriate safeguards 
                  are in place for all data sharing.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">6. Data Retention</h2>
                <p className="mb-4">
                  We retain your personal data for as long as necessary to fulfill the purposes for which it was 
                  collected, including to satisfy legal, accounting, or reporting requirements. Typically, this 
                  means retaining data for at least 7 years after the end of our relationship.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">7. Your Rights</h2>
                <p className="mb-4">You have the right to:</p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>Access your personal data</li>
                  <li>Rectify inaccurate data</li>
                  <li>Request erasure of your data</li>
                  <li>Object to processing</li>
                  <li>Request data portability</li>
                  <li>Withdraw consent</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">8. Contact Us</h2>
                <p className="mb-4">
                  For privacy-related inquiries, please contact us at{' '}
                  <a href="mailto:privacy@easysendservices.com" className="text-[#4FB3DF] hover:underline">
                    privacy@easysendservices.com
                  </a>
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
